import * as React from 'react'
import { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'

const Chat: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component="svg"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 54 54"
    fill="none"
    {...props}
  >
    <path
      d="M24.6184 12.7536C23.2155 16.5875 24.2874 20.2779 26.6686 22.659C28.3225 24.3129 30.6082 25.3352 33.1348 25.3352H36.4594V30.2187C36.4594 30.5846 36.8894 30.781 37.1659 30.5416L45.4855 23.3404L45.9344 22.9581C45.9676 22.9248 46.0092 22.8916 46.0424 22.8583C47.821 21.196 48.9265 18.819 48.9265 16.1926C48.9265 13.6658 47.9042 11.3803 46.2502 9.72631C44.5962 8.07234 42.3106 7.05005 39.7839 7.05005H33.0826C29.363 7.05027 25.8965 9.26056 24.6184 12.7536Z"
      fill="#3D3C38"
    />
    <path
      d="M30.6414 20.3485H41.4463C41.9053 20.3485 42.2774 19.9763 42.2774 19.5173C42.2774 19.0583 41.9053 18.6862 41.4463 18.6862H30.6414C30.0204 18.6862 29.6188 19.3424 29.9013 19.8954C30.0434 20.1735 30.3292 20.3485 30.6414 20.3485Z"
      fill="#FF612B"
    />
    <path
      d="M30.6414 17.024H41.4463C41.9053 17.024 42.2774 16.6518 42.2774 16.1928C42.2774 15.7338 41.9053 15.3617 41.4463 15.3617H30.6414C30.0204 15.3617 29.6188 16.0179 29.9013 16.571C30.0434 16.8489 30.3292 17.024 30.6414 17.024Z"
      fill="#FF612B"
    />
    <path
      d="M30.6414 13.6994H41.4463C41.9053 13.6994 42.2774 13.3273 42.2774 12.8683C42.2774 12.4093 41.9053 12.0371 41.4463 12.0371H30.6414C30.0204 12.0371 29.6188 12.6933 29.9013 13.2464C30.0434 13.5245 30.3292 13.6994 30.6414 13.6994Z"
      fill="#FF612B"
    />
    <path
      d="M22.9368 20.3346H15.3782C12.5284 20.3346 9.95035 21.4876 8.08476 23.3532C6.21917 25.2188 5.06616 27.7967 5.06616 30.6467C5.06616 33.609 6.313 36.2901 8.3191 38.1651C8.35667 38.2026 8.40347 38.2401 8.44094 38.2776L8.94719 38.7088L18.3311 46.8312C18.6431 47.1012 19.128 46.8795 19.128 46.467V40.9587H22.8778C25.7277 40.9587 28.3057 39.8055 30.1713 37.9399C32.857 35.2542 34.0661 31.0917 32.4838 26.7673C31.0422 22.8277 27.1322 20.3346 22.9368 20.3346Z"
      fill="#FF612B"
    />
    <path
      d="M25.6904 35.3342H13.5034C12.9857 35.3342 12.5659 34.9144 12.5659 34.3967C12.5659 33.879 12.9857 33.4592 13.5034 33.4592H25.6904C26.3908 33.4592 26.8439 34.1995 26.5253 34.8232C26.3649 35.1367 26.0425 35.3342 25.6904 35.3342Z"
      fill="#002677"
    />
    <path
      d="M25.6904 31.5843H13.5034C12.9857 31.5843 12.5659 31.1645 12.5659 30.6468C12.5659 30.1291 12.9857 29.7094 13.5034 29.7094H25.6904C26.3908 29.7094 26.8439 30.4496 26.5253 31.0733C26.3649 31.3868 26.0425 31.5843 25.6904 31.5843Z"
      fill="#002677"
    />
    <path
      d="M25.6904 27.8344H13.5034C12.9857 27.8344 12.5659 27.4147 12.5659 26.8969C12.5659 26.3792 12.9857 25.9595 13.5034 25.9595H25.6904C26.3908 25.9595 26.8439 26.6997 26.5253 27.3234C26.3649 27.637 26.0425 27.8344 25.6904 27.8344Z"
      fill="#002677"
    />
  </Box>
)

export default Chat
